import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CustomInterceptor {
  
  intercept(req: HttpRequest<string>, next: HttpHandler): Observable<HttpEvent<string>> {

    // const cloned = req.clone({

    //   setHeaders: {

    //     'x-apigw-api-id': environment.gateway.id
    //   }
    // });

    return next.handle(req);
  }
}
